/**
 * @generated SignedSource<<2ae1a99fcd0e6948c83bac039c3dfcef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateChangeDescriptionMutation$variables = {
  json: any;
  text: string;
  updateId: string;
};
export type UpdateChangeDescriptionMutation$data = {
  readonly Objective_EditUpdateDescription: {
    readonly update: {
      readonly data: any;
      readonly id: string;
    };
  } | null;
};
export type UpdateChangeDescriptionMutation$rawResponse = {
  readonly Objective_EditUpdateDescription: {
    readonly update: {
      readonly __typename: string;
      readonly data: any;
      readonly id: string;
    };
  } | null;
};
export type UpdateChangeDescriptionMutation = {
  rawResponse: UpdateChangeDescriptionMutation$rawResponse;
  response: UpdateChangeDescriptionMutation$data;
  variables: UpdateChangeDescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "json"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "text"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "updateId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "json",
    "variableName": "json"
  },
  {
    "kind": "Variable",
    "name": "text",
    "variableName": "text"
  },
  {
    "kind": "Variable",
    "name": "updateId",
    "variableName": "updateId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "data",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateChangeDescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "EditUpdateDescriptionMutation",
        "kind": "LinkedField",
        "name": "Objective_EditUpdateDescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateChangeDescriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "EditUpdateDescriptionMutation",
        "kind": "LinkedField",
        "name": "Objective_EditUpdateDescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f7e9050166e5d92cb0655db4cbfdaa8b",
    "id": null,
    "metadata": {},
    "name": "UpdateChangeDescriptionMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateChangeDescriptionMutation(\n  $updateId: ID!\n  $text: String!\n  $json: JSON!\n) {\n  Objective_EditUpdateDescription(updateId: $updateId, text: $text, json: $json) {\n    update {\n      __typename\n      id\n      data\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3bcddbddd35f1adefffbaedc0f9e4570";

export default node;
